import { FormProvider } from 'react-hook-form'

import { Button, Card, Collapsible, Form, Stack, TextContainer, Toast } from '@shopify/polaris'

import { useAccountSettingsForm } from '../hooks/useAccountSettingsForm'
import { segment } from '../util/createSegmentPicker'
import { getTranslation } from '../util/getTranslation'
import { GoPayDefaultInstrument } from './GoPayDefaultInstrument'
// import { SettingsContactCard } from './SettingsContactCard'
import { SettingsLanguage } from './SettingsLanguage'
import { SettingsPaymentLabel } from './SettingsPaymentLabel'
import { SettingsNumericId } from './SettingsNumericId'
import { useEffect, useState } from 'react'
import { TAccountActivationStatus } from '@sga/shopify-payments-types'
import { useAuth } from './AuthContext'
import { createApi } from '../api'
import { getGoPayLanguageOptions } from '../util/getLanguageOptions'

type TProps = {
  goBack: () => any
  status: TAccountActivationStatus
}
GoPayAccountSettings.segment = segment('gopay')

export function GoPayAccountSettings({ goBack, status }: TProps) {
  const { appType } = useAuth()
  const [advancedCollapsibleOpen, setAdvancedCollapsibleOpen] = useState(false)
  const [appStatus, setAppStatus] = useState({ cardPayment: false, bankPayment: false })

  const { form, saveStatus, setSaveStatus, onSubmit } = useAccountSettingsForm((api, formValues) =>
    api.saveConfig(formValues),
  )

  useEffect(() => {
    if (status !== 'new' && !appType) {
      const api = createApi()
      api.appStatus().then(({ appStatus }) => {
        setAppStatus(appStatus)
      })
    }
  }, [status, appType])

  if (status === 'new') {
    // Don't bother user with too much stuff initially
    return null
  }

  return (
    <Card title={getTranslation('settings.gateway_settings')}>
      <FormProvider {...form}>
        <Form onSubmit={onSubmit}>
          {/* Removing currently no need for this */}
          {/* <SettingsContactCard /> */}
          <GoPayDefaultInstrument appStatus={appStatus} />
          <SettingsLanguage languages={getGoPayLanguageOptions()} />
          <SettingsPaymentLabel />
          <Card.Section title={getTranslation('settings.advanced_api_settings')}>
            <TextContainer>
              <b>
                {getTranslation('settings.advanced_settings_warning')}
              </b>
            </TextContainer>
            <br />

            <Button onClick={() => setAdvancedCollapsibleOpen(!advancedCollapsibleOpen)}>
              {advancedCollapsibleOpen ? getTranslation('common.hide') : getTranslation('common.display')}
            </Button>

            <Collapsible id="advanced-settings-collapsable" open={advancedCollapsibleOpen}>
              <br />
              <SettingsNumericId />
            </Collapsible>
          </Card.Section>
          <Card.Section>
            <Stack distribution="equalSpacing">
              <Button onClick={goBack}>{getTranslation('common.change_credentials')}</Button>
              <Button primary submit disabled={form.formState.isSubmitting}>
                {getTranslation('common.save_settings')}
              </Button>
            </Stack>
          </Card.Section>
        </Form>
      </FormProvider>
      {saveStatus === 'success' && (
        <Toast
          content={getTranslation('common.settings_saved')}
          onDismiss={() => setSaveStatus('submit')}
        />
      )}
      {saveStatus === 'failure' && (
        <Toast
          content={getTranslation('common.saving_failed')}
          error
          onDismiss={() => setSaveStatus('submit')}
        />
      )}
    </Card>
  )
}

